
<div class="scrollable-container" #container>
    <div class="card border sticky-div" #stickyDiv [ngClass]="{
        'fixed-min-width-large': infoProject?.actualState === 'fixed',
        'fixed-min-width-small': infoProject?.actualState === 'fixed' && isScreenSmall
    }">
        <div class="card-header px-2 py-2" [ngClass]="infoProject?.actualState == 'fixed' ? 'bg-primary-card' : 'bg-secondary-card'">
            <p>
                {{ getProjectStateText(infoProject?.actualState) }}
            </p>
        </div>

        <div class="card-body px-2 py-1">

            <div class="d-md-flex justify-content-between py-1">
                <p>Invierte desde:</p>
                <p class="dates" [ngClass]="infoProject?.actualState == 'fixed' ? 'cl-primary-card' : 'cl-secondary-card'">${{ phase?.partValue | number }}</p>
            </div>

            <div class="d-md-flex justify-content-between py-1">
                <p>{{ infoProject?.actualState == 'fixed' ? 'Plazo: ' : 'Plazo estimado: '}} </p>
                <p class="dates" [ngClass]="infoProject?.actualState == 'fixed' ? 'cl-primary-card' : 'cl-secondary-card'">{{ infoProject?.monthsEstimateResidential }}</p>
            </div>
            <div class="col-12 ps-2 pe-2 py-1">
                <div class="row">
                    <div class="col-8 ps-1">
                        <div class="d-flex align-items-center h-100">
                            <p>Evaluación Monific:<a href="https://centrodeayuda.monific.com/qu%C3%A9-es-la-evaluaci%C3%B3n-monific" target="_blank">
                                <img class="ms-1 mb-1" width="12" src="/assets/icons/info.svg" alt="info"></a></p>
                        </div>
                    </div>
                    <div class="col-4">
                        <div class="row">
                            <div class="col-12 ps-0 text-letter" [ngClass]="getLetterClass()">
                                {{ infoProject?.ratingProject }}
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-3"><div class="line rb-back"></div></div>
                            <div class="col-3"><div class="line mb-back"></div></div>
                            <div class="col-3"><div class="line rm-back"></div></div>
                            <div class="col-3"><div class="line ra-back"></div></div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="card-performance px-2 py-1">
            @if(!infoProject?.statusCardCTC && infoProject?.actualState == 'fixed') {
                <div class="cards-container mt-2 px-2">
                    <div class="cards-info mb-2" [ngClass]="infoProject?.actualState == 'fixed' ? 'w-auto' : 'w-78'">
                        <div class="title mb-2"><p class="fw-sbold fs-11" [ngClass]="infoProject?.actualState == 'fixed' ? 'cl-primary-card' : 'cl-secondary-card'">Rendimiento anual fijo</p></div>
                        <div class="subtitle"><p class="fs-14 cl-primary fw-bold">{{ infoProject?.performance }} %</p></div>
                    </div>
                </div>
            } @else if (!infoProject?.statusCardCTC && infoProject?.actualState == 'variable' || infoProject?.statusCardCTC ) {
                <p class="text-center fw-sbold mb-3 my-2" [ngClass]="infoProject?.actualState == 'fixed' ? 'cl-primary-card' : 'cl-secondary-card'">TIR anual estimada</p>
                <div class="cards-container d-flex flex-wrap align-items-center mt-2 px-2">
                    @for(item of performanceData; track item.id){
                    <div class="cards-info mb-2"  [ngClass]="infoProject?.actualState == 'fixed' ? 'w-auto' : 'w-78'">
                            <div class="title mb-2"><p class="fw-sbold fs-11" [ngClass]="infoProject?.actualState == 'fixed' ? 'cl-primary-card' : 'cl-secondary-card'">{{ item.value }}</p></div>
                            <div class="subtitle"><p class="fs-9">{{ item.label }}</p></div>
                        </div>
                    }
                </div>
            }
        </div>

        <div class="card-achoraded px-2 py-1">
            <p class="mb-2 fs-13 text-center" [innerHTML]="labelFreeParts"></p>
            <div class="progress-container">
                <div class="bg-line">
                  <div class="bg-process" [style.width.%]="percentage" [ngClass]="infoProject?.actualState == 'fixed' ? 'bg-primary-card' : 'bg-secondary-card'">
                    <div class="message text-center fs-13" [style.right.px]="rightPosition()"> <span class="circle" [style.transform]="getSpanTranslate()"></span><span class="arrow" [style.transform]="getSpanTranslate()"></span>{{ message }}</div>
                  </div>
                </div>
              </div>
            <div class=" part-number fs-14">
                <div class="first d-flex justify-content-between pb-2" [ngClass]="phase?.active >= 1 ? '' : 'border-bottom'">
                    <p class="fw-sbold fs-13">Monto fondeado: </p>
                    <p class="fw-bold fs-13">$ {{ ( phase?.funded * 1000 ) | number }}</p>
                </div>
                <div class="second mt-2" *ngIf="phase?.free >= 1">
                    <div class="mt-1 ps-2 d-flex justify-content-between">
                    <div class="amount-dot min"></div>
                    <p class="fs-12">Mínimo</p>
                    <p class="ms-auto fw-sbold fs-12 p-min">$ {{ ( phase?.minAmountProject * 1000 ) | number }}</p>
                    </div>
                    <div class="ps-2 d-flex justify-content-between">
                    <div class="amount-dot max"></div>
                    <p class="fs-12">Máximo</p>
                    <p class="ms-auto fw-sbold fs-12 p-max">$ {{ ( phase?.total * 1000 ) | number }}</p>
                    </div>
                </div>
            </div>
        </div>

        <div class="card-foter px-2 py-1">
            <p class="text-1 py-1" *ngIf="phase?.free >= 1">{{ restDayTotal }}</p>
            <button class="btn" *ngIf="phase?.free >= 1" (click)="next(infoProject)" [ngClass]="infoProject?.actualState == 'fixed' ? 'bg-primary-card' : 'bg-secondary-card'">Quiero invertir</button>

            <div class="d-flex align-items-center justify-content-evenly my-3" *ngIf="infoProject?.resale" >
                <div class="col-5 lightslategrey" *ngIf="infoProject?.resale" >
                    <p class="m-0 fs-11 cr-pointer"[routerLink]="[resaleBuyUserPartPath, infoProject?.pid]">
                        <a>Ir al mercado secundario</a>
                    </p>
                </div>
                <div class="col-5 lightslategrey" *ngIf="infoProject?.resale" >
                    <p class="m-0 fs-11 cr-pointer"[routerLink]="[resaleUserPartPath, infoProject?.pid]">
                        <a>Vender mis participaciones</a>
                    </p>
                </div>
            </div>

            <hr *ngIf="phase?.free == 0">
            <p class="text-2 py-1 mt-2" [ngClass]="infoProject?.actualState == 'fixed' ? 'cl-primary-card' : 'cl-secondary-card'">{{ (totalPartsUsers | number) || 0 }} Inversionistas en el proyecto</p>
        </div>

    </div>

    </div>
